export const Revenue = [
  {
    label: '$500 or less',
    value: 500,
  },
  {
    label: '$600 - $700',
    value: 650,
  },
  {
    label: '$700 - $800',
    value: 750,
  },
  {
    label: '$800 - $900',
    value: 850,
  },
  {
    label: '$900 - $1,000',
    value: 950,
  },
  {
    label: '$1,000 or more',
    value: 1000,
  },
];

export const CallPercentage = [
  {
    label: '50 or less',
    value: 50,
  },
  {
    label: '60 - 70',
    value: 65,
  },
  {
    label: '70 - 80',
    value: 75,
  },
  {
    label: '80 - 90',
    value: 85,
  },
  {
    label: '90 - 100',
    value: 95,
  },
  {
    label: '100',
    value: 100,
  },
];

export const SoldPercentage = [
  {
    label: '50 or less',
    value: 50,
  },
  {
    label: '60 - 70',
    value: 65,
  },
  {
    label: '70 - 80',
    value: 75,
  },
  {
    label: '80 - 90',
    value: 85,
  },
  {
    label: '90 - 100',
    value: 95,
  },
  {
    label: '100',
    value: 100,
  },
];

export const ResultHowCards = [
  {
    iconType: 'icon-reporting',
    title: 'Online Booking Portal',
    description: `Homeowners can now book your services with just a few clicks, streamlining the customer service experience and keeping your CAC down.`,
  },
  {
    iconType: 'icon-marketing',
    title: 'Marketing Analytics',
    description: `Real-time campaign statistics, phone number tracking, and heat maps make sure you're putting your ad dollars where they matter most.`,
  },
  {
    iconType: 'icon-call-booking',
    title: 'Call Recording',
    description: `Easy access to every call your CSRs take lets you monitor performance, provide coaching, and sharpen the intake process.`,
  },
  {
    iconType: 'icon-signup',
    title: 'Required/Gated Forms & Checklists',
    description: `Customizable forms can now prompt your techs through every stage of the job cycle, making incomplete paperwork a thing of the past.`,
  },
  {
    iconType: 'icon-commercial',
    title: 'Technician Scorecard',
    description: `Closing rates, job types, and various other key metrics now let you see where each tech is excelling and where the strengths of your team lie.`,
  },
  {
    iconType: 'icon-dispatch',
    title: 'Smart Dispatch',
    description: `An intuitive dispatching dashboard makes fleet management and matching your techs to the most lucrative jobs as simple as a drag-and-drop.`,
  },
];
